import React from 'react';
import EmptySvg from './empty.svg';
import './style.less';

interface EmptyProps {
  /** 自定义描述文字 */
  description?: React.ReactNode;
  /** 自定义图片 */
  image?: React.ReactNode;
  /** 图片高度 */
  imageHeight?: number | string;
  /** 自定义底部内容（如按钮等） */
  children?: React.ReactNode;
  /** 自定义样式类名 */
  className?: string;
  /** 自定义样式 */
  style?: React.CSSProperties;
}

const Empty: React.FC<EmptyProps> = ({
  description = '暂无数据',
  image,
  imageHeight = 120,
  children,
  className = '',
  style,
}) => {
  const renderImage = () => {
    if (image) {
      return <div className="empty-image-custom">{image}</div>;
    }

    return (
      <img
        src={EmptySvg}
        alt="暂无数据"
        className="empty-image"
        style={{ height: imageHeight }}
      />
    );
  };

  return (
    <div className={`empty-container ${className}`} style={style}>
      <div className="empty-content">
        {renderImage()}
        {description && (
          <div className="empty-description">
            {description}
          </div>
        )}
        {children && (
          <div className="empty-footer">
            {children}
          </div>
        )}
      </div>
    </div>
  );
};

export { Empty };
